
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helprVHRv5zDjW936dXeS7WbeDI1K1stAvTkMrBvk8aIyIgMeta } from "/usr/src/app/apps/frontend/www/pages/help.vue?macro=true";
import { default as indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta } from "/usr/src/app/apps/frontend/www/pages/index.vue?macro=true";
import { default as gcuLvHC9POzHtEMc_9JFscoSW66qmonrzsiLlmtayVIPzcMeta } from "/usr/src/app/apps/frontend/www/pages/legals/gcu.vue?macro=true";
import { default as _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue?macro=true";
import { default as _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue?macro=true";
import { default as _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue?macro=true";
import { default as _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue?macro=true";
import { default as _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue?macro=true";
import { default as _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue?macro=true";
import { default as Step1WithTripH2pYxJaGFphOQ99KCg2HCmnkMInFt_CMGScE8y3qcZIMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue?macro=true";
import { default as Step1WithoutTriplHKUg_45OSnJVk3KIeczHw3yo32zkwqtN6auSVoy_45H43AMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue?macro=true";
import { default as stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta } from "/usr/src/app/apps/frontend/www/pages/quote/steps.vue?macro=true";
import { default as index3Dn2u3ZFxiZcDG34xpPJ9tOFOIp9k_45ziAxkJlSeqYTYMeta } from "/usr/src/app/apps/frontend/www/pages/trips/index.vue?macro=true";
import { default as helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta } from "/usr/src/app/apps/frontend/www/pages/account/help.vue?macro=true";
import { default as indexGRpiUxGFRbCcq5E_T8A03uSHrs7cOAVYIgPhMt82I0MMeta } from "/usr/src/app/apps/frontend/www/pages/legals/index.vue?macro=true";
import { default as _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta } from "/usr/src/app/apps/frontend/www/pages/trips/[slug].vue?macro=true";
import { default as indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta } from "/usr/src/app/apps/frontend/www/pages/account/index.vue?macro=true";
import { default as infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta } from "/usr/src/app/apps/frontend/www/pages/account/infos.vue?macro=true";
import { default as indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta } from "/usr/src/app/apps/frontend/www/pages/articles/index.vue?macro=true";
import { default as become_45partnerWhabustAGrbNmB_450l5bR01Of2cZ4KPVPcAgOhUVPbu4Meta } from "/usr/src/app/apps/frontend/www/pages/become-partner.vue?macro=true";
import { default as privacyGpsmYBQbj9qa__3flz6fwWE24s8MxawKrzvh6JliBqAMeta } from "/usr/src/app/apps/frontend/www/pages/legals/privacy.vue?macro=true";
import { default as _91slug_931HSsTfVczmn_X0D5gm184UoDZIlGY2mWQXt3TSXkJKwMeta } from "/usr/src/app/apps/frontend/www/pages/articles/[slug].vue?macro=true";
import { default as forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta } from "/usr/src/app/apps/frontend/www/pages/forgot-password.vue?macro=true";
import { default as _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta } from "/usr/src/app/apps/frontend/www/pages/welcome/[token].vue?macro=true";
import { default as _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta } from "/usr/src/app/apps/frontend/www/pages/trips/[category].vue?macro=true";
import { default as who_45we_45areCQBTaSMC8RR_B46A_V_ks8Y3CEMF4B3QbrR_453gTCTjwMeta } from "/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue?macro=true";
import { default as indexi62PceNyLQEnAouOf2ebaFWiZ2gGZLFPEG3XqlhkPvQMeta } from "/usr/src/app/apps/frontend/www/pages/destinations/index.vue?macro=true";
import { default as datesTIn5menJ07ApH5lBjBhDutdGyGpJwCq7KD2Jd5OabBwMeta } from "/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue?macro=true";
import { default as wishes9lqUjJK0xJL6_45WRqHv0OMRsEmI3146vxQIcIF0PHpdkMeta } from "/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue?macro=true";
import { default as projectfjB_vCC4L_RskxRkv7yl9JXN4lFKcZOctSR_5_eiizkMeta } from "/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue?macro=true";
import { default as travelersRFSTFUu2uh2g1_45Vkm24bIIVpR9W_45WuCcRr8vBE5ET_MMeta } from "/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue?macro=true";
import { default as _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta } from "/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue?macro=true";
import { default as _91slug_93rpby1Xk0ssSGdFRDOeqxy_451ixc8aDxVY5233y1jq0vkMeta } from "/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue?macro=true";
import { default as _91provider_931YTCD35Z6iSBU3bXEQ14E9TV2_45_45K5PnF7k1Ij9e2FoYMeta } from "/usr/src/app/shared/common/pages/connexion/[provider].vue?macro=true";
import { default as conditionsUe1BN5RLkH8SB7haS__rgy7fGdYmDz1XJJ7ZbYRcYC4Meta } from "/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue?macro=true";
import { default as voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta } from "/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue?macro=true";
import { default as component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta } from "/usr/src/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_b4non55rg7etplnd7xlqm3g2be/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438 } from "/usr/src/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_b4non55rg7etplnd7xlqm3g2be/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "help___de",
    path: "/de/hilfe",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___en",
    path: "/en/help",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___es",
    path: "/es/ayuda",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___fr",
    path: "/aide",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___it",
    path: "/it/aiuto",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___nl",
    path: "/nl/help",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "help___pt",
    path: "/pt/ajuda",
    component: () => import("/usr/src/app/apps/frontend/www/pages/help.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexOvyPBkDU43RzNGwCD8oKuuf8tEU9EfSslRTeFpckvzkMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/index.vue")
  },
  {
    name: "legals-gcu___de",
    path: "/de/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___en",
    path: "/en/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___es",
    path: "/es/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___fr",
    path: "/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___it",
    path: "/it/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___nl",
    path: "/nl/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "legals-gcu___pt",
    path: "/pt/legals/gcu",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/gcu.vue")
  },
  {
    name: "quote-steps___de",
    path: "/de/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___de",
    path: "/de/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___de",
    path: "/de/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___de",
    path: "/de/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___de",
    path: "/de/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___de",
    path: "/de/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___de",
    path: "/de/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___de",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___de",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___en",
    path: "/en/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___en",
    path: "/en/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___en",
    path: "/en/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___en",
    path: "/en/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___en",
    path: "/en/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___en",
    path: "/en/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___en",
    path: "/en/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___en",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___en",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___es",
    path: "/es/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___es",
    path: "/es/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___es",
    path: "/es/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___es",
    path: "/es/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___es",
    path: "/es/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___es",
    path: "/es/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___es",
    path: "/es/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___es",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___es",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___fr",
    path: "/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___fr",
    path: "/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___fr",
    path: "/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___fr",
    path: "/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___fr",
    path: "/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___fr",
    path: "/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___fr",
    path: "/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___fr",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___fr",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___it",
    path: "/it/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___it",
    path: "/it/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___it",
    path: "/it/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___it",
    path: "/it/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___it",
    path: "/it/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___it",
    path: "/it/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___it",
    path: "/it/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___it",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___it",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___nl",
    path: "/nl/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___nl",
    path: "/nl/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___nl",
    path: "/nl/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___nl",
    path: "/nl/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___nl",
    path: "/nl/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___nl",
    path: "/nl/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___nl",
    path: "/nl/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___nl",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___nl",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "quote-steps___pt",
    path: "/pt/quote/steps",
    meta: stepslN5NO3pxsJ9tGMOmQqDWQLtjesXw_45bTQINpTJF286PYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps.vue"),
    children: [
  {
    name: "quote-steps-02-dates___pt",
    path: "/pt/quote/dates",
    meta: _02_45datesrYSogTnnviyq83YDpu0boe_45ZMV1uMKIJG6WFJUmA2jsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/02-dates.vue")
  },
  {
    name: "quote-steps-05-phone___pt",
    path: "/pt/quote/phone",
    meta: _05_45phoneKD8sVcPB2ufaVf0Coi4PZgagTD2HhE43O33wu6iN2dUMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/05-phone.vue")
  },
  {
    name: "quote-steps-04-project___pt",
    path: "/pt/quote/project",
    meta: _04_45projectv_Ji16OPCa90lzWow_otYzf6b_6mp_y629L4ACyCrKgMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/04-project.vue")
  },
  {
    name: "quote-steps-03-travelers___pt",
    path: "/pt/quote/travelers",
    meta: _03_45travelers0uDV9tdWnGR88WLDrT24hfs1xmjS6jumhJ2MvhLS3_45EMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/03-travelers.vue")
  },
  {
    name: "quote-steps-01-destinations___pt",
    path: "/pt/quote",
    meta: _01_45destinationsFR1YKHidPxGURiG9FR_45QXQ_XGhQiY44N2zdun_45mWOLQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/01-destinations.vue")
  },
  {
    name: "quote-steps-06-confirmation___pt",
    path: "/pt/quote/confirmation",
    meta: _06_45confirmationCIDVCB_45xiLtlM3FCrBj9G8xaRHNlQcObiOkR_45W099_45oMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/06-confirmation.vue")
  },
  {
    name: "quote-steps-_components-Step1WithTrip___pt",
    path: "_components/Step1WithTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithTrip.vue")
  },
  {
    name: "quote-steps-_components-Step1WithoutTrip___pt",
    path: "_components/Step1WithoutTrip",
    component: () => import("/usr/src/app/apps/frontend/www/pages/quote/steps/_components/Step1WithoutTrip.vue")
  }
]
  },
  {
    name: "trips___de",
    path: "/de/reisen",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___en",
    path: "/en/trips",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___es",
    path: "/es/viajes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___fr",
    path: "/sejours",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___it",
    path: "/it/viaggi",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___nl",
    path: "/nl/reizen",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "trips___pt",
    path: "/pt/viagens",
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/index.vue")
  },
  {
    name: "account-help___de",
    path: "/de/account/help",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___en",
    path: "/en/account/help",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___es",
    path: "/es/cuenta/ayuda",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___fr",
    path: "/compte/aide",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___it",
    path: "/it/account/help",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___nl",
    path: "/nl/account/help",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "account-help___pt",
    path: "/pt/account/help",
    meta: helpW535fty9OmnJG9KO_p22jwy8ulZnMJZtDg_tJwLEJ9AMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/help.vue")
  },
  {
    name: "legals___de",
    path: "/de/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___en",
    path: "/en/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___es",
    path: "/es/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___fr",
    path: "/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___it",
    path: "/it/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___nl",
    path: "/nl/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "legals___pt",
    path: "/pt/legals",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/index.vue")
  },
  {
    name: "trips-slug___de",
    path: "/de/reisen/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___en",
    path: "/en/trips/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___es",
    path: "/es/viajes/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___fr",
    path: "/sejours/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___it",
    path: "/it/viaggi/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___nl",
    path: "/nl/reizen/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "trips-slug___pt",
    path: "/pt/viagens/:slug()",
    meta: _91slug_93mvUsLGUakBjlHaZ9T6quNfesMta85ciSf0OH3_457K2OMMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[slug].vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___es",
    path: "/es/cuenta",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/compte",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___it",
    path: "/it/account",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account___pt",
    path: "/pt/account",
    meta: indexj_45xTAaAY5H7RT7aCZ3m4V46Y1unKDuZEXUUgaeGRuxYMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/index.vue")
  },
  {
    name: "account-infos___de",
    path: "/de/account/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___en",
    path: "/en/account/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___es",
    path: "/es/cuenta/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___fr",
    path: "/compte/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___it",
    path: "/it/account/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___nl",
    path: "/nl/account/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "account-infos___pt",
    path: "/pt/account/infos",
    meta: infos6PtvA4eaKAc_45iiHacOg5xm0nIoqQOKSLMlyx9XP59ksMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/infos.vue")
  },
  {
    name: "articles___de",
    path: "/de/inspiration",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___en",
    path: "/en/inspiration",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___es",
    path: "/es/inspiraciones",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___fr",
    path: "/inspiration",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___it",
    path: "/it/inspirazioni",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___nl",
    path: "/nl/inspiraties",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "articles___pt",
    path: "/pt/inspiracoes",
    meta: indexmuMWnVeCzkvalwcc2pN5nSGddjVTvJ0qQ_Hc1q1qBOQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/index.vue")
  },
  {
    name: "become-partner___de",
    path: "/de/werden-partner",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___en",
    path: "/en/become-partner",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___es",
    path: "/es/ser-parte",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___fr",
    path: "/devenir-partenaire",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___it",
    path: "/it/diventare-partner",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___nl",
    path: "/nl/worden-partner",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "become-partner___pt",
    path: "/pt/ser-parte",
    component: () => import("/usr/src/app/apps/frontend/www/pages/become-partner.vue")
  },
  {
    name: "legals-privacy___de",
    path: "/de/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___en",
    path: "/en/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___es",
    path: "/es/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___fr",
    path: "/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___it",
    path: "/it/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___nl",
    path: "/nl/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "legals-privacy___pt",
    path: "/pt/legals/privacy",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/privacy.vue")
  },
  {
    name: "articles-slug___de",
    path: "/de/inspiration/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___en",
    path: "/en/inspiration/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___es",
    path: "/es/inspiraciones/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___fr",
    path: "/inspiration/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___it",
    path: "/it/inspirazioni/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___nl",
    path: "/nl/inspiraties/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "articles-slug___pt",
    path: "/pt/inspiracoes/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/articles/[slug].vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/mot-de-passe-oublie",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___nl",
    path: "/nl/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pt",
    path: "/pt/forgot-password",
    meta: forgot_45passwordCNx6T_45Ofz5Fv2aJg9fpiNBLZaFk70TvHt2ltTDnZWWQMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/forgot-password.vue")
  },
  {
    name: "welcome-token___de",
    path: "/de/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___en",
    path: "/en/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___es",
    path: "/es/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___fr",
    path: "/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___it",
    path: "/it/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___nl",
    path: "/nl/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "welcome-token___pt",
    path: "/pt/welcome/:token()",
    meta: _91token_93W7OVPtN43AMcfUn_LZK8lXUKezj2NsYphKxqgtYtH_45gMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/welcome/[token].vue")
  },
  {
    name: "trips-category___de",
    path: "/de/reisen/kategorie/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___en",
    path: "/en/trips/category/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___es",
    path: "/es/viajes/categoria/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___fr",
    path: "/sejours/categorie/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___it",
    path: "/it/viaggi/categoria/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___nl",
    path: "/nl/reizen/categorie/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "trips-category___pt",
    path: "/pt/viagens/categoria/:category()",
    meta: _91category_93DBHzUKvRmYHHzQSvmHr4MONgKj76gZLUCb7LX_P_45cfAMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/trips/[category].vue")
  },
  {
    name: "legals-who-we-are___de",
    path: "/de/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___en",
    path: "/en/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___es",
    path: "/es/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___fr",
    path: "/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___it",
    path: "/it/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___nl",
    path: "/nl/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "legals-who-we-are___pt",
    path: "/pt/legals/who-we-are",
    component: () => import("/usr/src/app/apps/frontend/www/pages/legals/who-we-are.vue")
  },
  {
    name: "destinations___de",
    path: "/de/reiseziele",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___en",
    path: "/en/destinations",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___es",
    path: "/es/destinos",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___fr",
    path: "/destinations",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___it",
    path: "/it/destinazioni",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___nl",
    path: "/nl/reisbestemmingen",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "destinations___pt",
    path: "/pt/destinos",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/index.vue")
  },
  {
    name: "account-quotes-id___de",
    path: "/de/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___de",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___de",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___de",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___de",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___en",
    path: "/en/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___en",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___en",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___en",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___en",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___es",
    path: "/es/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___es",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___es",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___es",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___es",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___fr",
    path: "/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___fr",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___fr",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___fr",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___fr",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___it",
    path: "/it/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___it",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___it",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___it",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___it",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___nl",
    path: "/nl/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___nl",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___nl",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___nl",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___nl",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "account-quotes-id___pt",
    path: "/pt/account/quotes/:id()",
    meta: _91id_93dZ69qA0hq0dSznHCV_45BRCOW1gH4ShNvVrAtvWCo6bWIMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id].vue"),
    children: [
  {
    name: "account-quotes-id-dates___pt",
    path: "dates",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/dates.vue")
  },
  {
    name: "account-quotes-id-wishes___pt",
    path: "wishes",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/wishes.vue")
  },
  {
    name: "account-quotes-id-project___pt",
    path: "project",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/project.vue")
  },
  {
    name: "account-quotes-id-travelers___pt",
    path: "travelers",
    component: () => import("/usr/src/app/apps/frontend/www/pages/account/quotes/[id]/travelers.vue")
  }
]
  },
  {
    name: "destinations-slug___de",
    path: "/de/reiseziele/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___en",
    path: "/en/destinations/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___es",
    path: "/es/destinos/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___fr",
    path: "/destinations/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___it",
    path: "/it/destinazioni/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___nl",
    path: "/nl/reisbestemmingen/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "destinations-slug___pt",
    path: "/pt/destinos/:slug()",
    component: () => import("/usr/src/app/apps/frontend/www/pages/destinations/[slug].vue")
  },
  {
    name: "connexion-provider",
    path: "/connexion/:provider()",
    meta: _91provider_931YTCD35Z6iSBU3bXEQ14E9TV2_45_45K5PnF7k1Ij9e2FoYMeta || {},
    component: () => import("/usr/src/app/shared/common/pages/connexion/[provider].vue")
  },
  {
    name: "special-offer-conditions___de",
    path: "/de/spezialangebot/bedingungen",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___en",
    path: "/en/special-offer/conditions",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___es",
    path: "/es/oferta-especial/condiciones",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___fr",
    path: "/offre-speciale/conditions",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___it",
    path: "/it/offerta-speciale/condizioni",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___nl",
    path: "/nl/speciale-aanbieding/voorwaarden",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "special-offer-conditions___pt",
    path: "/pt/oferta-especial/condi%C3%A7%C3%B5es",
    component: () => import("/usr/src/app/apps/frontend/www/pages/special-offer/conditions.vue")
  },
  {
    name: "landing-voyage-sur-mesure___de",
    path: "/de/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___en",
    path: "/en/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___es",
    path: "/es/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___fr",
    path: "/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___it",
    path: "/it/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___nl",
    path: "/nl/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: "landing-voyage-sur-mesure___pt",
    path: "/pt/landing/voyage-sur-mesure",
    meta: voyage_45sur_45mesure4Q9_45SCADY9MK8ygbVvhDjd3J227HMhMNXOuoecjKvJsMeta || {},
    component: () => import("/usr/src/app/apps/frontend/www/pages/landing/voyage-sur-mesure.vue")
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  },
  {
    name: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438Meta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubiTNfqA4eYUNNZy2XX56Ci5r_45qnHlamR6wcw4JcQC438
  }
]